export default __webpack_public_path__ + "static/media/CardCompressionRatio.e4aec5e7.svg";